import { api } from "../../../../../../helpers/apiHelperV3";
const API_SECURITY = "/accounts/v3/security/session/";

// /accounts/v3/security/session/register2fa
export const register2fa = async () => {
  const url = API_SECURITY + "register2fa";
  try {
    const response = await api.post(url);
    return {
      success: true,
      data: response,
    };
  } catch (error: any) {
    return {
      success: false,
      error: error?.message || "Failed to register 2FA",
    };
  }
};

// /accounts/v3/security/session/verify2fa
export const verify2fa = async (code: string) => {
  const url = API_SECURITY + "verify2fa";
  try {
    const response = await api.post(url, { code });
    return {
      success: true,
      data: response,
    };
  } catch (error: any) {
    console.log("!!error", error);
    // {"errors":[{"messages":["Invalid two factor authentication code."]}]}
    const errorMessages = error?.response?.data?.errors[0]?.messages;

    return {
      success: false,
      errorMessages: errorMessages,
    };
  }
};

// /accounts/v3/security/session/delete2fa
export const remove2fa = async () => {
  const url = API_SECURITY + "delete2fa";
  try {
    const response = await api.delete(url);
    return {
      success: true,
      data: response,
    };
  } catch (error: any) {
    return {
      success: false,
      error: error?.message || "Failed to remove 2FA",
    };
  }
};
